module.exports = __webpack_public_path__ + "img/ic_pl.8d551430.svg";